import { render, staticRenderFns } from "./GameSelection.vue?vue&type=template&id=fb13f89a&scoped=true"
import script from "./GameSelection.vue?vue&type=script&lang=js"
export * from "./GameSelection.vue?vue&type=script&lang=js"
import style0 from "./GameSelection.vue?vue&type=style&index=0&id=fb13f89a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb13f89a",
  null
  
)

export default component.exports